import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import storageSession from "redux-persist/es/storage/session";
import { persistReducer } from "redux-persist";
import { RootState } from "../../../app/store";
import { RecommendedService } from "../../../app/models/features/recommendedServices/recommendedService";
import { RecommendedOptionCodeEnum } from "../../../app/enums/recommendedOptionCodeEnum";

const initialState = {
    recommendedServices: [] as RecommendedService[],
};

const slice = createSlice({
    name: "recommendedServicesSlice",
    initialState,
    reducers: {
        addRecommendedService: (state, { payload }: PayloadAction<RecommendedService>) => {
            state.recommendedServices.push(payload);
        },
        removeRecommendedService: (state, { payload }: PayloadAction<{ optionCode: string }>) => {
            state.recommendedServices = state.recommendedServices.filter(
                (service) => service.optionCode !== payload.optionCode
            );
        },
        setRecommendedServiceCost: (state, { payload }: PayloadAction<{ optionCode: string; cost: number }[]>) => {
            payload.forEach(({ optionCode, cost }) => {
                const serviceIndex = state.recommendedServices.findIndex(
                    (service) => service.optionCode === optionCode
                );
                if (serviceIndex !== -1) {
                    state.recommendedServices[serviceIndex].cost = cost;
                }
            });
        },
        setCargoTimeSlot: (
            state,
            {
                payload,
            }: PayloadAction<{ optionCode: RecommendedOptionCodeEnum; cargoTimeSlot: string }>
        ) => {
            const serviceIndex = state.recommendedServices.findIndex(
                (service) => service.optionCode === payload.optionCode
            );
            if (serviceIndex !== -1) {
                state.recommendedServices[serviceIndex].cargoTimeSlot = payload.cargoTimeSlot;
            }
        },
        setRecommendedServicesInitialState: () => initialState,
        setRecommendedServices: (state, { payload }: PayloadAction<RecommendedService[]>) => {
            state.recommendedServices = payload;
        },
    },
});

export const {
    addRecommendedService,
    removeRecommendedService,
    setRecommendedServiceCost,
    setCargoTimeSlot,
    setRecommendedServicesInitialState,
    setRecommendedServices,
} = slice.actions;

export default slice.reducer;

const recommendedServicesPersistConfig = {
    key: "recommendedServices",
    storage: storageSession,
};

export const recommendedServicesPersistedReducer = persistReducer(recommendedServicesPersistConfig, slice.reducer);

export const selectRecommendedServices = (state: RootState) => state.recommendedServicesSlice.recommendedServices;
